<template>
  <v-container class="estate-duty-costs-container">
    <InJourneyAccordion :accordionData="accordionData" :padding="padding" />
  </v-container>
</template>

<script>
  import InJourneyAccordion from '../common/InJourneyAccordion.vue';
  import { formatCurrency } from '../../constants/js/currency-input';

  export default {
    name: 'EstateDutyCosts',
    components: {
      InJourneyAccordion,
    },
    props: {
      testator: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        estateCostCalculation: this.testator.estateCostCalculation,
      };
    },
    computed: {
      padding() {
        return this.$vuetify.breakpoint.mdAndDown ? 30 : 60;
      },
      executorFeePercentage() {
        return this.estateCostCalculation.executorFeePercentage;
      },
      bulletOne() {
        return 'These values are illustrative of the costs based on the information you have provided and will change over time, review your will and estate at regular intervals';
      },
      bulletTwo() {
        if (this.testator.maritalRegime === 'OUT_OF_COMMUNITY_ACCRUAL') {
          return 'The estimated estate administration costs do not take into account adjustments for the accrual in terms of your marriage. Neither does it make provision for income tax or capital gains tax payable in the year of your passing.';
        } else {
          return 'The estimated estate administration costs do not make provision for income tax or capital gains tax payable in the year of your passing.';
        }
      },
      bulletThree() {
        return `If your estate does not have R ${formatCurrency(
          this.estateCostCalculation.estimatedEstateAdministrativeCosts
        )} cash to cover these costs plus any outstanding debts you may have,
                your assets will be sold in order to cover these costs.`;
      },
      accordionData() {
        return [
          {
            alwaysExpanded: false,
            masterTitle: 'Estate Duty & Taxes',
            title: 'Estate Duty',
            price: this.estateCostCalculation.estateDuty,
            content: {
              headerAndTitles: [
                {
                  header: `Dutiable estate before 4A deduction: <span style="text-wrap: nowrap;">R ${formatCurrency(
                    this.estateCostCalculation.dutiableEstateBefore4aDeduction
                  )}</span>`,
                  smallHeader: true,
                  price: undefined,
                  description:
                    'This is a tax payable to the South African Revenue Service on your dutiable estate. The first R3.5 million is exempt from estate duty.',
                },
              ],
              headerContainer: {
                title: 'Estimated estate administration costs',
                price:
                  this.estateCostCalculation.estimatedEstateAdministrativeCosts,
              },
              title: 'Please Note:',
              bullets: [this.bulletOne, this.bulletTwo, this.bulletThree],
            },
          },
        ];
      },
    },
    created() {},
    methods: {},
  };
</script>

<style lang="scss">
  .estate-duty-costs-container {
    width: 100%;
    padding: 0;
  }
</style>
